import {DefaultPortModel, DefaultPortModelOptions, PortModel} from "@projectstorm/react-diagrams";
import {NodeLinkModel} from "../links/NodeLinkModel";
import {PortDefinition} from "../../editorSlice";
import {DataNodeModel} from "../nodes/DataNodeModel";
import {PortModelAlignment} from "@projectstorm/react-diagrams-core";
import {
    DeserializeEvent,
  } from "@projectstorm/react-canvas-core";
import {Action} from "../../../editor/editorSlice"



export class DataPortModel extends DefaultPortModel {
    avro:any
    actions!:Action[]

    constructor(options: DefaultPortModelOptions | boolean, name?: string, label?: string,actions?:Action[]) {
        if (!!name) {
            options = {
                in: !!options,
                name: name,
                label: label
            };
        }
        options = options as DefaultPortModelOptions;
        super({
            label: options.label || options.name,
            alignment: options.in ? PortModelAlignment.LEFT : PortModelAlignment.RIGHT,
            type: 'data',
            ...options
        });
        if(actions) {
            this.actions = actions
        }
    }


    // @ts-ignore
    createLinkModel(): NodeLinkModel | null {
        return new NodeLinkModel();
    }

    // canLinkToPort(port: any): boolean {
    //     if(Object.keys(port.getLinks()).length ===1 && port.parent.kind === "sink"){
    //         // console.warn('to many link for this port')
    //         return false
    //     }
    //     if (port instanceof DefaultPortModel) {
    //         return this.options.in !== port.getOptions().in;
    //     }
    //     return true;
    // }

    getDefinition(): PortDefinition | undefined {
        const sc = this.getNode().schema
        if(sc){
            if(this.options.in){
              return sc.input?.find(p => p.name === this.getName())
            }
            else {
                return sc.output?.find(p => p.name === this.getName())
            }
        }
        return undefined
    }

    getNode(): DataNodeModel {
        return super.getNode() as DataNodeModel;
    }

    setAvro(avro: any) {
        this.avro = avro
    }

    getSourcePort() {
      for(let link of Object.keys(this.getLinks())) {
            return link        
      }
      return null
    } 

    serialize() {
        return {
          ...super.serialize(),
          avro : this.avro,
          actions: this.actions
        };
      }
    
      deserialize(event: DeserializeEvent<this>): void {
        super.deserialize(event);
        this.avro = event.data.avro;
        this.actions = event.data.actions     
     }
}
